import React from 'react';
import { Link } from 'react-router-dom';
import { SkewButton, SectionTitle, Card, GradientDivider } from '../components/UIComponents';
import { Zap, Users, Heart, Target, ChevronRight, Dumbbell, BookOpen, Coffee, Salad, Flame, Calendar, Clock } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_goalgeous-hub/artifacts/ad5dhro0_Untitled%20design.png";

const IMAGES = {
  hero: "https://images.unsplash.com/photo-1616803824305-a07cfbc8ea60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxzdHJvbmclMjBhZnJpY2FuJTIwYW1lcmljYW4lMjB3b21hbiUyMGZpdG5lc3MlMjBneW0lMjB3b3Jrb3V0fGVufDB8fHx8MTc3MDc2MzU5MXww&ixlib=rb-4.1.0&q=85",
  community: "https://images.unsplash.com/photo-1662549905044-e3f71c293989?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxncm91cCUyMGZpdG5lc3MlMjBjbGFzcyUyMHdvbWVuJTIwZGl2ZXJzZSUyMGVuZXJnZXRpYyUyMGd5bXxlbnwwfHx8fDE3NzA3NjM1OTV8MA&ixlib=rb-4.1.0&q=85",
  vibe: "https://images.unsplash.com/photo-1623804421482-721b3901c125?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxuZW9uJTIwZ3ltJTIwbGlnaHRpbmclMjBlbmVyZ2V0aWMlMjBmaXRuZXNzJTIwYXRtb3NwaGVyZXxlbnwwfHx8fDE3NzA3NjM2MTJ8MA&ixlib=rb-4.1.0&q=85",
};

const features = [
  {
    icon: Dumbbell,
    title: "Power Up Your Fitness",
    description: "THE POWER ROOM group training, personal coaching, and classes designed to push your limits.",
    link: "/power-up",
    color: "lime"
  },
  {
    icon: BookOpen,
    title: "GOALGEOUS University",
    description: "Confidence coaching, mindset training, and personal development.",
    link: "/goalgeous-university",
    color: "pink"
  },
  {
    icon: Users,
    title: "Club Deuces",
    description: "Group fitness community with energizing classes and schedules.",
    link: "/club-deuces",
    color: "lime"
  },
  {
    icon: Zap,
    title: "SHOCK THE BODY",
    description: "High-energy training powered by 2000WATTS. Energy. Intensity. Results.",
    link: "/shock-the-body",
    color: "lime"
  },
  {
    icon: Salad,
    title: "GOAL-TRITION",
    description: "Clean eating lifestyle with meal plans and protein shakes.",
    link: "/goal-trition",
    color: "pink"
  }
];

const values = [
  { icon: Zap, title: "Power", text: "Build strength that radiates from within" },
  { icon: Users, title: "Community", text: "A sisterhood that lifts you higher" },
  { icon: Heart, title: "Self-Love", text: "Transform your body, embrace yourself" },
  { icon: Target, title: "Goals", text: "Stay accountable, stay GOALGEOUS" }
];

const classSchedule = [
  {
    day: "MONDAY",
    classes: [
      { time: "5:00 AM", name: "Power Obsession", instructor: "2000WATTS" },
      { time: "6:00 AM", name: "Power Obsession", instructor: "Queen Jean" },
      { time: "6:10 PM", name: "Power Obsession", instructor: "Coach Deuces" }
    ]
  },
  {
    day: "TUESDAY",
    classes: [
      { time: "5:00 AM", name: "Power Circuit", instructor: "2000WATTS" },
      { time: "6:00 AM", name: "Power", instructor: "Club Deuces" },
      { time: "6:10 PM", name: "Power Up Circuit", instructor: "Kita" }
    ]
  },
  {
    day: "WEDNESDAY",
    classes: [
      { time: "5:00 AM", name: "Wildin'", instructor: "Kita" },
      { time: "6:00 AM", name: "Wildin'", instructor: "Kita" },
      { time: "6:10 PM", name: "Power Obsession", instructor: "Queen Jean" }
    ]
  },
  {
    day: "THURSDAY",
    classes: [
      { time: "5:00 AM", name: "Fire & Flow", instructor: "2000WATTS" },
      { time: "6:00 AM", name: "Burn & Flow", instructor: "Queen Jean" },
      { time: "6:10 PM", name: "Step. Build. Burn.", instructor: "Coach Deuces" }
    ]
  },
  {
    day: "FRIDAY",
    classes: [
      { time: "5:00 AM", name: "Power Bootcamp", instructor: "2000WATTS" },
      { time: "6:00 AM", name: "Power Bootcamp", instructor: "Queen Jean" }
    ]
  },
  {
    day: "SATURDAY",
    classes: [
      { time: "7:20 AM", name: "Power Sculpt", instructor: "Queen Jean" }
    ]
  }
];

export const HomePage = () => {
  return (
    <div data-testid="home-page" className="bg-brand-black">
      {/* Hero Section */}
      <section data-testid="hero-section" className="relative min-h-screen flex items-center">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <img 
            src={IMAGES.hero} 
            alt="Strong woman working out" 
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-black via-brand-black/80 to-transparent" />
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-32 md:py-0">
          <div className="max-w-3xl">
            <p className="font-oswald text-sm uppercase tracking-[0.3em] text-brand-lime mb-4 animate-fade-in">
              Welcome to the Movement
            </p>
            <h1 className="font-oswald text-5xl md:text-7xl font-bold uppercase tracking-tighter text-white mb-6 animate-fade-in delay-100">
              More than fitness.<br />
              <span className="gradient-text">This is a movement.</span>
            </h1>
            <p className="font-montserrat text-lg md:text-xl text-brand-gray leading-relaxed mb-8 animate-fade-in delay-200">
              We hold women to the highest level of accountability through structured nutrition tracking, consistent support, and bootcamp-style workouts designed to push real results.
            </p>
            <div className="flex flex-wrap gap-4 animate-fade-in delay-300">
              <SkewButton href="#programs" testId="hero-cta-primary">
                Start Your Journey
              </SkewButton>
              <SkewButton variant="secondary" href="/about" testId="hero-cta-secondary">
                Learn More
              </SkewButton>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-brand-lime rounded-full flex justify-center">
            <div className="w-1 h-3 bg-brand-lime rounded-full mt-2 animate-pulse" />
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section data-testid="values-section" className="py-24 bg-brand-dark">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div 
                key={value.title}
                data-testid={`value-${value.title.toLowerCase()}`}
                className="text-center group"
              >
                <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center transition-all duration-300 ${index % 2 === 0 ? 'bg-brand-lime/10 group-hover:bg-brand-lime/20' : 'bg-brand-pink/10 group-hover:bg-brand-pink/20'}`}>
                  <value.icon size={28} className={index % 2 === 0 ? 'text-brand-lime' : 'text-brand-pink'} />
                </div>
                <h3 className="font-oswald text-xl uppercase tracking-wide text-white mb-2">{value.title}</h3>
                <p className="font-montserrat text-sm text-brand-gray">{value.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Class Schedule Section */}
      <section data-testid="class-schedule-section" className="py-24 bg-brand-black">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Calendar size={32} className="text-brand-lime" />
              <h2 className="font-oswald text-4xl md:text-6xl font-bold uppercase tracking-tighter text-white">
                Class <span className="text-brand-lime">Schedule</span>
              </h2>
            </div>
            <div className="w-32 h-1 bg-gradient-to-r from-brand-lime to-brand-pink mx-auto mb-6" />
            <p className="font-montserrat text-brand-gray text-lg">
              All Power Up sessions include strength, cardio, core, and stretch.
            </p>
          </div>

          {/* Schedule List */}
          <div className="space-y-8">
            {classSchedule.map((dayData, dayIndex) => (
              <div 
                key={dayData.day}
                data-testid={`schedule-day-${dayData.day.toLowerCase()}`}
                className="border-l-4 border-brand-lime pl-6"
              >
                {/* Day Header */}
                <h3 className="font-oswald text-2xl md:text-3xl uppercase tracking-wider text-brand-pink mb-4">
                  {dayData.day}
                </h3>
                
                {/* Classes for this day */}
                <div className="space-y-3">
                  {dayData.classes.map((cls, idx) => (
                    <div 
                      key={idx}
                      className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3"
                    >
                      {/* Time */}
                      <span className="font-oswald text-brand-lime text-lg font-bold min-w-[90px]">
                        {cls.time}
                      </span>
                      {/* Separator on desktop */}
                      <span className="hidden sm:inline text-brand-gray">–</span>
                      {/* Class Name & Instructor */}
                      <span className="font-oswald text-white text-lg">
                        <span className="font-bold">{cls.name}</span>
                        {cls.instructor && (
                          <span className="text-brand-gray font-normal"> with {cls.instructor}</span>
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Book Your Class Button */}
          <div className="text-center mt-16">
            <a
              href="/book-now"
              data-testid="book-class-btn"
              className="inline-flex items-center justify-center gap-3 bg-brand-lime text-brand-black px-12 py-5 font-oswald text-xl uppercase tracking-wider transform -skew-x-6 hover:bg-brand-pink hover:text-white transition-all duration-300"
            >
              <span className="skew-x-6 flex items-center gap-3">
                <Calendar size={24} />
                Book Your Class
              </span>
            </a>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section id="programs" data-testid="programs-section" className="py-24 bg-brand-black">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <SectionTitle 
            title="Our Programs" 
            subtitle="Transform Your Life"
            className="mb-16"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {features.map((feature, index) => (
              <Link 
                key={feature.title} 
                to={feature.link}
                data-testid={`program-card-${feature.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <Card className="p-8 h-full group cursor-pointer">
                  <div className={`w-14 h-14 rounded-lg flex items-center justify-center mb-6 transition-all duration-300 ${feature.color === 'lime' ? 'bg-brand-lime/10 group-hover:bg-brand-lime/20' : 'bg-brand-pink/10 group-hover:bg-brand-pink/20'}`}>
                    <feature.icon size={28} className={feature.color === 'lime' ? 'text-brand-lime' : 'text-brand-pink'} />
                  </div>
                  <h3 className="font-oswald text-2xl uppercase tracking-tight text-white mb-3 group-hover:text-brand-lime transition-colors">
                    {feature.title}
                  </h3>
                  <p className="font-montserrat text-brand-gray leading-relaxed mb-4">
                    {feature.description}
                  </p>
                  <div className={`flex items-center gap-2 font-oswald text-sm uppercase tracking-wider ${feature.color === 'lime' ? 'text-brand-lime' : 'text-brand-pink'}`}>
                    <span>Explore</span>
                    <ChevronRight size={16} className="group-hover:translate-x-2 transition-transform" />
                  </div>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section data-testid="community-section" className="py-24 bg-brand-dark relative overflow-hidden">
        <div className="absolute top-0 right-0 w-1/2 h-full opacity-30">
          <img 
            src={IMAGES.community} 
            alt="Fitness community" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-brand-dark" />
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="max-w-xl">
            <SectionTitle 
              title="Join the Sisterhood" 
              subtitle="Community First"
              accent="pink"
              className="mb-8"
            />
            <p className="font-montserrat text-lg text-brand-gray leading-relaxed mb-8">
              While the work is intense, the mission is deeper. We build confidence. We create discipline. We cultivate a community of women who support each other, grow together, and glow from within.
            </p>
            <GradientDivider />
            <div className="mt-8 space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-brand-lime/20 flex items-center justify-center">
                  <span className="font-oswald text-brand-lime font-bold">500+</span>
                </div>
                <span className="font-montserrat text-white">Active Community Members</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-brand-pink/20 flex items-center justify-center">
                  <span className="font-oswald text-brand-pink font-bold">20+</span>
                </div>
                <span className="font-montserrat text-white">Weekly Classes</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section data-testid="cta-section" className="py-24 bg-brand-black relative">
        <div className="absolute inset-0 opacity-20">
          <img 
            src={IMAGES.vibe} 
            alt="Energetic atmosphere" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center">
          <img 
            src={LOGO_URL} 
            alt="Power Up Your Fitness" 
            className="h-24 mx-auto mb-8"
          />
          <h2 className="font-oswald text-4xl md:text-6xl font-bold uppercase tracking-tight text-white mb-6">
            Ready to <span className="text-brand-lime">Power Up</span>?
          </h2>
          <p className="font-montserrat text-lg text-brand-gray mb-8 max-w-2xl mx-auto">
            This is where strength is built. This is where confidence returns. This is where women find themselves again.
          </p>
          <SkewButton testId="cta-join-now">
            Join the Movement
          </SkewButton>
        </div>
      </section>
    </div>
  );
};
